import {
  collection,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { firestore } from "../../../helpers/firebaseConfig";

export const MONITORING_API_URL = "https://google-traffic-collector-api-554232563465.us-west1.run.app/runs";

export async function startMonitoringRun({ collectionId, durationMinutes, pollingIntervalSeconds, paths }) {
  const payload = {
    data_collection_id: collectionId,
    duration_minutes: durationMinutes,
    polling_interval_seconds: pollingIntervalSeconds,
    paths: paths.map((path) => ({
      path_id: path.id,
      points: path.points.map((point) => ({
        longitude: Number(point.lng ?? point.longitude),
        latitude: Number(point.lat ?? point.latitude),
      })),
    })),
  };

  const response = await fetch(MONITORING_API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(result.detail || "Could not start traffic collection.");
    error.status = response.status;
    throw error;
  }
  return result;
}

export function subscribeToMonitoringRuns(collectionId, onRuns, onError) {
  const ref = collection(firestore, "data-collection", collectionId, "runs");
  return onSnapshot(query(ref, orderBy("created_at", "desc")), (snapshot) => {
    onRuns(snapshot.docs.map((runDoc) => ({ id: runDoc.id, ...runDoc.data() })));
  }, onError);
}

export function subscribeToPathRunSamples(collectionId, pathId, runId, onSamples, onError) {
  const ref = collection(firestore, "data-collection", collectionId, "paths", pathId, "data");
  // Keep this to a single-field query so deployments do not need a composite
  // Firestore index for run_id + sample_index. Samples are small and sorted locally.
  const samplesQuery = query(ref, where("run_id", "==", runId));
  return onSnapshot(samplesQuery, (snapshot) => {
    onSamples(snapshot.docs
      .map((sampleDoc) => ({ id: sampleDoc.id, ...sampleDoc.data() }))
      .sort((a, b) => Number(a.sample_index ?? 0) - Number(b.sample_index ?? 0)));
  }, onError);
}
